import React, { useState } from 'react';
import Slider from 'react-slick';
import { useDispatch } from 'react-redux';
import {reset} from 'redux-form';
import { getProducts } from '@app/src/utils/categories';
import {
  Wrapper,
  Container,
  LabelAnnouncement,
  Title,
  Content,
  Subtitle,
  Text,
  List,
  Item,
  ImageCategory,
  Note,
  ButtonPublish,
  Description,
  ImageWrapper,
  IconWrapperNext,
  IconWrapperPrev
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { ModalInterested } from '@app/src/views/Home/listProducts';
import { clearLeadData } from '@app/src/common/formContact';

interface Props {
  currentSlide?: number;
  slideCount?: number;
}

const ButtonNextArrow: React.FC<Props> = ({ currentSlide, slideCount, ...props }) => (
  <div {...props}
    className={'slick-next slick-arrow slick-opportunity-category' +
      (currentSlide === slideCount - 1 ? ' slick-disabled' : '')}
    aria-hidden='true'
    aria-disabled={currentSlide === slideCount - 1 ? true : false}
  >
    <IconWrapperNext >
      <Icon data-name="icon-expand-more" fill="#fff" width="15" height="15" />
    </IconWrapperNext>
  </div>
);

const ButtonPrevArrow: React.FC<Props> = ({ currentSlide, slideCount, ...props }) => (
  <div {...props}
    className={'slick-prev slick-arrow slick-opportunity-category' +
      (currentSlide === 0 ? ' slick-disabled' : '')}
    aria-hidden='true'
    aria-disabled={currentSlide === slideCount - 1 ? true : false}
  >
    <IconWrapperPrev>
      <Icon data-name="icon-expand-more" fill="#fff" width="15" height="15" />
    </IconWrapperPrev>
  </div>
);


const PRODUCTS = getProducts();
const settings = {
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <ButtonNextArrow />,
  prevArrow: <ButtonPrevArrow />
};

export const CategorySlider: React.FC = () => {
  const dispatch = useDispatch();
  const [isShowModal, setIsShowModal] = useState(false);

  const handleClickPublish = (e) => {
    e.preventDefault();
    setIsShowModal(true);
  };

  const handleCloseModal = () => {
    setIsShowModal(!isShowModal);
    dispatch(clearLeadData());
    dispatch(reset('formInterested'));
  };

  return (
    <Wrapper id="desplegados" data-scroll="desplegados">
      <Container>
        <LabelAnnouncement>
          Nuevo: Avisos desplegados
        </LabelAnnouncement>
        <Title>
          ¿Sabías que un aviso con medida te genera mayor exposición?
        </Title>
        <Text>Genera mayor impacto llegando a tus clientes potenciales con avisos desde <strong>S/100</strong></Text>
        <Slider {...settings}>
          {
            PRODUCTS && PRODUCTS.length > 0 && PRODUCTS.map((data, index) => (
              <div key={index}>
                <Content>
                  <Description>
                    <Text>Genera mayor impacto llegando a tus clientes potenciales con avisos desde <strong>S/100</strong></Text>
                    <Subtitle>{data.highLightsSummary && data.highLightsSummary.text}</Subtitle>
                    <List>
                      {
                        data.highLightsSummary && data.highLightsSummary.description &&
                        data.highLightsSummary.description.map((text, index) => (
                          <Item key={index}>{text}</Item>
                        ))
                      }
                    </List>
                    <ButtonPublish href="#" onClick={handleClickPublish}>Empieza tu publicación</ButtonPublish>
                    <Note>*Alcance a más de 100,000 personas</Note>
                    <Note>**Público objetivo: NSE B/C</Note>
                  </Description>
                  <ImageWrapper>
                    <ImageCategory src={data && data.bgImage} alt="image" />
                    <Note>*Alcance a más de 100,000 personas</Note>
                    <Note>**Público objetivo: NSE B/C</Note>
                  </ImageWrapper>
                </Content>
              </div>
            ))
          }
        </Slider>
      </Container>
      <ModalInterested isDisplay={isShowModal} handleCloseModal={handleCloseModal} />
    </Wrapper>
  )
};